export default __webpack_public_path__ + "static/teamspective-logo-regular-inverted-65aed5a2da003ef4013514e8b5843262.svg";